import React from "react";
import { AuthenticationManager, ResourceID } from "../../../common/AuthenticationManager";
import { GenericMessages, ObjectType } from "../../../common/Constants";
import { StringHelper } from "../../../common/Helpers";
import RestClient from "../../../common/RestClient";
import { BreadCrumb } from "../../common/BreadCrumb";
import { ConfirmDialog } from "../../common/ConfirmDialog";
import { ScheduleConfirmationDialog } from "../../common/ScheduleConfirmationDialog";
import { CancelPreviewButton } from "../common/CancelPreviewButton";
import { CardMode } from "../common/CardMode";
import { PromotionDetailCard } from "./cards/PromotionDetailCard";
import { PromotionPreview } from "./preview/PromotionPreview";
import { HistoryDialog } from "../../common/HistoryDialog";
import { PromotionCardMovie } from "./cards/PromotionCardMovie";
import { PromotionCategory } from "../../../common/Constants";
import { ScheduledPromotionService } from "../../../services/ScheduledPromotionService";
import {
  PromotionMovieReleaseListing
} from "./cards/PromotionMovieReleaseListing";
import {
  NavigationItem,
  NavigationSettings,
} from "../../common/NavigationSettings";
import { toast } from "react-toastify";
import ButtonActionDetailGroup from "../../common/ButtonActionDetailGroup";

const EditPageName = "Edit Promotion";
const ViewPageName = "View Promotion";

export class PromotionDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardMode: CardMode.View,
      generalInfo: null,
      generalInfoValidations: [],
      promotion: null,
      promotionId: "",
      showCancelDialog: false,
      showConfirmDialog: false,
      showPreview: false,
      showScheduleDialog: false,
      showHistoryDialog: false,
      promotionMovieReleases: [],
      scheduledPromotions: []
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    const promotionId = StringHelper.toNumber(id);
    if (isNaN(id) || promotionId <= 0) {
      this.redirectToListingPage();
      return;
    }
    this.loadScheduledPromotions(id);
    this.setState({ promotionId }, this.refreshData);
  }

  loadScheduledPromotions = (id) => {
    new ScheduledPromotionService().get("", { promotionId: id })
      .then((response) => {
        this.setState({ scheduledPromotions: response.data.data });
      });
  }

  isValidated() {
    const { generalInfoValidations } = this.state;
    return generalInfoValidations.every((val) => val.isValid);
  }

  loadPromotion(id) {
    RestClient.sendGetRequest(
      `/api/v1/promotions/${id}`,
      (response) => {
        this.setState({ promotion: response });
      },
      (error) => {
        toast.error(error.message);
      }
    );
  }

  loadMovieReleases = () => {
    const { id } = this.props.match.params;
    RestClient.sendGetRequest(
      `api/v1/movie_releases/get_promotion_movie_releases/${id}`,
      (response) => {
        this.setState({ promotionMovieReleases: response });
      },
      (error) => toast.error(error.message)
    );
  }

  onEditPromotionClick = () => {
    this.setState({ cardMode: CardMode.Update });
  };

  onGeneralInfoModelChange = (model) => {
    const displayStartTime = StringHelper.toDateTimeString(
      model.displayStartTimeStr
    );
    const displayEndTime = StringHelper.toDateTimeString(
      model.displayEndTimeStr
    );
    const category = StringHelper.toNumber(model.category, 0);
    const weightDisplay = StringHelper.toNumber(model.weightDisplay, 0);
    const newModel = Object.assign(model, {
      category,
      displayStartTime,
      displayEndTime,
      weightDisplay,
    });
    this.setState({ generalInfo: newModel });
  };

  onGeneralInfoValidationsChange = (validations) => {
    this.setState({ generalInfoValidations: validations });
  };

  onHideCancelDialog = () => {
    this.setState({ showCancelDialog: false });
  };

  onHideConfirmDialog = () => {
    this.setState({ showConfirmDialog: false });
  };

  onHidePreview = () => {
    this.setState({ showPreview: false });
  };

  onHideScheduleDialog = () => {
    this.setState({ showScheduleDialog: false });
  };

  onProceedCancelDialog = () => {
    this.setState({
      cardMode: CardMode.View,
      promotion: Object.assign({}, this.state.promotion),
      showCancelDialog: false,
    });
  };

  onPromotionMovieEditChange = (value) => {
    this.setState({ isEdit: value });
  };

  onChangeCacheReleases = (value) => {
    this.setState({ cachesReleases: value });
  };


  onPromotionMovieModelChange = (model) => {
    let promotionMovieReleases = [];
    model.promotionMovies.forEach((item) => {
      promotionMovieReleases = promotionMovieReleases.concat(item.selectedMovieReleases);
    });
    this.setState({ promotionMovieReleases: promotionMovieReleases });
  };

  onPromotionMovieValidationsChange = (validations) => {
    this.setState({ promotionMovieValidations: validations });
  };

  onProceedConfirmDialog = () => {
    if (!this.isValidated()) {
      this.setState({ isSubmit: true, showConfirmDialog: false });
      return;
    }
    const { generalInfo, promotionId, promotionMovieReleases } = this.state;
    const request = Object.assign(
      {},
      generalInfo, { movieReleaseIds: promotionMovieReleases.map(x => x.id) }
    );
    RestClient.sendPutRequest(
      `/api/v1/promotions/${promotionId}`,
      request,
      (response) => {
        this.loadScheduledPromotions(promotionId);
        toast.success(GenericMessages.PublishChangesSuccessfulMessage);
        this.setState({
          cardMode: CardMode.View,
          isSubmit: false,
          promotion: response,
          showConfirmDialog: false,
        });
      },
      (errorResponse) => {
        toast.error(errorResponse.message);
        this.setState({
          showConfirmDialog: false,
        });
      }
    );
  };

  onProceedScheduleDialog = (e) => {
    const { generalInfo, promotionId } = this.state;
    const request = Object.assign(
      {
        livePromotionId: promotionId,
      },
      e,
      generalInfo
    );
    RestClient.sendPostRequest(
      `/api/v1/scheduled_promotions/`,
      request,
      (response) => {
        toast.success(GenericMessages.ScheduleChangesSuccessfulMessage);
        this.setState({
          cardMode: CardMode.View,
          isSubmit: false,
          showScheduleDialog: false,
        });
      },
      (errorResponse) => {
        toast.error(errorResponse.message);
        this.setState({
          showScheduleDialog: false,
        });
      }
    );
  };

  onShowCancelDialog = () => {
    this.setState({ showCancelDialog: true });
  };

  onShowConfirmDialog = () => {
    if (!this.isValidated()) {
      this.setState({ isSubmit: true });
      return;
    }
    this.setState({ showConfirmDialog: true });
  };

  onShowPreview = () => {
    this.setState({ showPreview: true });
  };

  onShowScheduleDialog = () => {
    if (!this.isValidated()) {
      this.setState({ isSubmit: true });
      return;
    }
    this.setState({ showScheduleDialog: true });
  };

  redirectToListingPage(additionalParameter) {
    this.props.history.push(`/promotions/${additionalParameter ?? ""}`);
  }

  refreshData() {
    const { promotionId } = this.state;
    this.loadPromotion(promotionId);
    this.loadMovieReleases();
  }

  onHistoryDialogClose = () => {
    this.setState({ showHistoryDialog: false });
  };

  getNavigationSettings = () => {
    const { cardMode } = this.state;
    return new NavigationSettings({
      rootModule: new NavigationItem({
        identifier: "website_managements",
        name: "Website Management",
      }),
      parentModule: new NavigationItem({
        identifier: "promotions",
        name: "Promotions",
      }),
      activeModule: new NavigationItem({
        identifier: "promotion-creation",
        name: CardMode.isViewMode(cardMode) ? ViewPageName : EditPageName,
      }),
    });
  };

  render() {
    const {
      cardMode,
      isSubmit,
      generalInfo,
      promotion,
      showCancelDialog,
      showConfirmDialog,
      showPreview,
      showScheduleDialog,
      showHistoryDialog,
      generalInfoValidations,
      promotionMovieReleases,
      scheduledPromotions
    } = this.state;
    if (showPreview) {
      const previewModel = Object.assign(
        {},
        generalInfo
      );
      return (
        <>
          <PromotionPreview promotion={previewModel} />
          <CancelPreviewButton onClick={this.onHidePreview} />
        </>
      );
    }

    return (
      <div className="main-content">
        <BreadCrumb navigationSettings={this.getNavigationSettings()} />
        <div className="section__content section__content--p30">
          <div className="container-fluid">
            {CardMode.isViewMode(cardMode) && (
              <div className="row mb-3">
                <div className="col">
                  <ButtonActionDetailGroup>
                    <ButtonActionDetailGroup.Item
                      className="btn btn-outline-secondary"
                      onClick={() => this.setState({ showHistoryDialog: true })}
                    >
                      History
                    </ButtonActionDetailGroup.Item>
                    {
                      AuthenticationManager.isAuthorized(
                        ResourceID.PromotionEditButtonPage
                      ) && (
                        <ButtonActionDetailGroup.Item
                          className="btn btn-primary"
                          value="Edit"
                          disabled={promotion ? undefined : "disabled"}
                          onClick={this.onEditPromotionClick}
                        >
                          <i className="fas fa-edit"></i> Edit
                        </ButtonActionDetailGroup.Item>)
                    }
                  </ButtonActionDetailGroup>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-md-12">
                <PromotionDetailCard
                  cardMode={cardMode}
                  defaultValue={promotion}
                  isSubmit={isSubmit}
                  model={generalInfo}
                  onModelChange={this.onGeneralInfoModelChange}
                  onValidationsChange={this.onGeneralInfoValidationsChange}
                />{cardMode !== CardMode.View && promotion?.category === PromotionCategory.Event && (
                  <PromotionCardMovie
                    displayStart={promotion?.displayStartTime}
                    displayEnd={promotion?.displayEndTime}
                    cardMode={cardMode}
                    model={promotion}
                    onEditableChange={this.onPromotionMovieEditChange}
                    onChangeCacheReleases={this.onChangeCacheReleases}
                    isSubmit={isSubmit}
                    promotionDetailValidations={generalInfoValidations}
                    onModelChange={this.onPromotionMovieModelChange}
                    onValidationsChange={this.onPromotionMovieValidationsChange}
                    listMovieReleases={promotionMovieReleases}
                  />)}
              </div>
            </div>
            {cardMode === CardMode.View && promotion?.category === PromotionCategory.Event && (
              <PromotionMovieReleaseListing
                listMovieReleases={promotionMovieReleases}
              />)}
            {cardMode !== CardMode.View && (
              <ButtonActionDetailGroup>
                <ButtonActionDetailGroup.Item
                  className="btn btn-outline-secondary"
                  onClick={this.onShowPreview}
                >
                  Preview
                </ButtonActionDetailGroup.Item>
                <ButtonActionDetailGroup.Item
                  className="btn btn-success"
                  onClick={this.onShowConfirmDialog}
                >
                  Save Changes
                </ButtonActionDetailGroup.Item>
                {
                  AuthenticationManager.isAuthorized(
                    ResourceID.PromotionEditButtonPage
                  ) && (
                    <ButtonActionDetailGroup.Item
                      className="btn btn-primary"
                      onClick={this.onShowScheduleDialog}
                    >
                      Schedule
                    </ButtonActionDetailGroup.Item>)}
                <ButtonActionDetailGroup.Item
                  className="btn btn-danger"
                  onClick={this.onShowCancelDialog}
                >
                  Cancel
                </ButtonActionDetailGroup.Item>
              </ButtonActionDetailGroup>
            )}

          </div>
        </div>
        <ConfirmDialog
          visible={showCancelDialog && promotion}
          onCancel={this.onHideCancelDialog}
          onProceed={this.onProceedCancelDialog}
          message={GenericMessages.CancelChangesDialogMessage}
          title={GenericMessages.CancelChangesDialogTitle}
        />
        <ConfirmDialog
          visible={showConfirmDialog && promotion}
          onCancel={this.onHideConfirmDialog}
          onProceed={this.onProceedConfirmDialog}
          message={GenericMessages.SaveChangesDialogMessage}
          title={GenericMessages.SaveChangesDialogTitle}
        />
        {showScheduleDialog && promotion && (
          <ScheduleConfirmationDialog
            onCancel={this.onHideScheduleDialog}
            onProceed={this.onProceedScheduleDialog}
            message={GenericMessages.ScheduleChangesDialogMessage("promotion")}
            warningMessage={GenericMessages.ScheduleWarningDialogMessage("promotion")}
            title={GenericMessages.ScheduleChangesDialogTitle}
            data={scheduledPromotions}
          />
        )}
        {showHistoryDialog && (
          <HistoryDialog
            objectId={promotion.id}
            onClose={this.onHistoryDialogClose}
            url="/api/v1/history_logs"
            objectType={ObjectType.Promotion}
          />
        )}
      </div>
    );
  }
}
